






import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'app-logo',
})
export default class AppLogo extends Vue {}
